import { render } from "./WorldPrice.vue?vue&type=template&id=1e267af9"
import script from "./WorldPrice.vue?vue&type=script&lang=js"
export * from "./WorldPrice.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__